module.exports = __webpack_public_path__ + "images/emoji/ferris_wheel.1f8ac59056ac00e1f0d8.png";